import { render } from "./CommentAutocomplete.vue?vue&type=template&id=4090b2c9&ts=true"
import script from "./CommentAutocomplete.vue?vue&type=script&lang=ts"
export * from "./CommentAutocomplete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__